<template>
    <div>

        <div class="panel panel-clinic">

            <div class="panel-heading collapsed" href="#form_practitioners" data-toggle="collapse">

                <div class="arrow-down"></div>

                <h2 class="panel-title">Utövare</h2>

            </div>

            <div id="form_practitioners" class="panel-collapse">
<!--            <div id="form_practitioners" class="panel-collapse collapse">-->

                <div class="panel-body" v-if="fetcher.initialized">

                  <div class="list-group" v-if="!fetcher.loading">
                    <div class="list-group-item" :key="`p${practitioner.id}`" v-for="practitioner in practitioners">
                      <row-practitioner-edit :practitioner="practitioner" :clinic="clinic" @patched="patched()" @abort="active_edit = null" v-if="practitioner.id === active_edit"  />
                      <row-practitioner-view :practitioner="practitioner" @edit="(id) => active_edit = id" v-else  />
                    </div>
                  </div>

                  <button class="btn btn-primary" @click="posterPost()" :disabled="poster.submitted">Lägg till utövare</button>

                </div>

            </div>

        </div>

    </div>
</template>

<script>

import fetcher from '../../../shared/mixins/fetcher'
import poster from '../../../shared/mixins/poster'

import rowPractitionerEdit from './formComponents/row-practitioner-edit.vue'
import RowPractitionerView from './formComponents/row-practitioner-view.vue'

export default {

    mixins: [
        fetcher,
        poster
    ],

    components: {
        RowPractitionerView,
        rowPractitionerEdit
    },

    props: {
        clinic: {
            required: true
        }
    },

    data () {
        return {
            active_edit: null,

            practitioners: [],
            fetcher: {
                autoFill: [
                    'practitioners'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/clinics/' + this.clinic.id + '/practitioners'
        },
        posterUrl () {
            return '/clinics/' + this.clinic.id + '/practitioners'
        }
    },

    methods: {
        posterSuccess (data) {
            this.active_edit = data.practitioner_id

            this.fetcherFetch()
        },
        patched () {
            this.active_edit = null
            this.fetcherFetch()
        }
    }

}
</script>
